export function getKeys<T extends string>(object: { [key in T]?: any }): T[] {
    return Object.keys(object) as T[]
}
